class DetailsToggle extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelectorAll('details');
    this.details.forEach((detail) => {
      detail.addEventListener('toggle', this.onToggle.bind(this));
    });

    // Add click event listener to the document
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  onDocumentClick(event) {
    this.details.forEach((detail) => {
      if (detail.open && !detail.contains(event.target)) {
        this.close(detail);
      }
    });
  }

  onToggle(event) {
    if (event.target.open) {
      this.details.forEach((detail) => {
        if (detail !== event.target) {
          this.close(detail);
        }
      });
    }
  }

  close(detail) {
    detail.open = false;
    const content = detail.querySelector('summary').nextElementSibling;
    if (content) {
      content.setAttribute('aria-expanded', 'false');
    }
  }
}

customElements.define('details-toggle', DetailsToggle);
